import { ComponentMessagesVO } from '@repo/types'
import { GenericAbortSignal } from 'axios'
import { fetcher } from '../utils'

export default async (
  sessionId: number,
  cursor: number = 0,
  signal: GenericAbortSignal
): Promise<ComponentMessagesVO> => {
  return fetcher(`/api/chats/${sessionId}/messages?cursor=${cursor}&offset=20`, 'GET', undefined, undefined, signal)
}
